<script lang="ts">
 export let size = 24;
 export let color = "black";
</script>

<svg width={size} height={size} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M12.6682 21.9998C18.1911 21.9998 22.6682 17.5226 22.6682 11.9998C22.6682 6.47691 18.1911 1.99976 12.6682 1.99976C7.14537 1.99976 2.66821 6.47691 2.66821 11.9998C2.66821 17.5226 7.14537 21.9998 12.6682 21.9998Z"
    fill={color}
    stroke={color}
    class={$$props.class}
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M16.5272 7.8865C16.6835 7.83438 16.8323 7.98313 16.7801 8.13948L14.8183 14.0251C14.7984 14.0849 14.7515 14.1317 14.6918 14.1516L8.80611 16.1135C8.64976 16.1656 8.50101 16.0169 8.55313 15.8605L10.515 9.97488C10.5349 9.91516 10.5818 9.86829 10.6415 9.84839L16.5272 7.8865Z"
    fill="white"
    stroke="white"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
